module.exports = __webpack_public_path__ + "img/ico-warn.f4bee2a2.svg";